import { defineComponent as l, openBlock as a, createElementBlock as i, createElementVNode as m, normalizeClass as n, withModifiers as r, renderSlot as t } from "vue";
import { ClassProp as d } from "../../shared/props.mjs";
const u = ["open"], C = /* @__PURE__ */ l({
  __name: "SfAccordionItem",
  props: {
    modelValue: {
      type: Boolean,
      default: !1
    },
    summaryClass: d
  },
  emits: ["update:modelValue"],
  setup(e) {
    return (o, s) => (a(), i("details", {
      open: e.modelValue,
      "data-testid": "accordion-item"
    }, [
      m("summary", {
        class: n([
          e.summaryClass,
          "list-none [&::-webkit-details-marker]:hidden cursor-pointer focus-visible:outline focus-visible:outline-offset focus-visible:rounded-sm"
        ]),
        onClick: s[0] || (s[0] = r((f) => o.$emit("update:modelValue", !e.modelValue), ["prevent"]))
      }, [
        t(o.$slots, "summary")
      ], 2),
      t(o.$slots, "default")
    ], 8, u));
  }
});
export {
  C as default
};
